module.exports = __webpack_public_path__ + "img/em2.a177c256.jpg";